<template>
  <div>
    <!--For CLipart layers-->
    <p class="title is-6 has-text-centered">Clipart Layers <b-button @click="addLayer()" type="is-success" size="is-small" icon-left="plus"></b-button></p>
    <b-collapse
      class="card"
      animation="slide"
      v-for="(layer, index) of layers"
      :key="`LAYER_${index}`"
      :open="isOpen == index"
      @open="isOpen = index">
      <template #trigger="props">
        <div class="card-header" role="button">
          <p class="card-header-title">
            {{ `Layer ${index + 1}` }}
          </p>
          <a class="card-header-icon">
            <b-icon :icon="props.open ? 'menu-down' : 'menu-up'"></b-icon>
          </a>
        </div>
      </template>
      <div class="card-content">
        <div class="columns is-multiline">
          <div class="column">
            <div class="buttons">
              <b-button type="is-danger" size="is-small" @click="removeLayer(index)">Remove</b-button>
              <b-button type="is-warning" size="is-small" @click="copyLayer(index)">Copy</b-button>
            </div>
            
          </div>
          <div class="column">
            <span v-if="currentLayerPage != null">Current Clipart is on page {{currentLayerPage}}</span>
          </div>
          <div class="column">
            <b-field v-if="show_track_count">
              <b-checkbox v-model="layer.is_count_tracking">Count Tracking</b-checkbox>
            </b-field>
          </div>
          <div class="column">
            <b-field v-if="show_track_count && layer.is_count_tracking">
              <b-numberinput v-model="layer.count_tracking_step">Count Tracking</b-numberinput>
            </b-field>
          </div>
          <div class="column">
            <b-field v-if="show_add_remove">
              <b-checkbox v-model="layer.allow_add_remove">Allow Add/Remove</b-checkbox>
            </b-field>
          </div>
          <div class="column">
            <b-field v-if="show_add_remove && layer.allow_add_remove" label="Max Display">
              <b-numberinput :controls="false" size="is-small" v-model="layer.max_display">Max Display</b-numberinput>
            </b-field>
          </div>
          <div class="column">
            <b-field label="Text to Speech">
              <b-input v-model="layer.tts_text" />
            </b-field>
          </div>
          </div>
          <div class="columns is-multiline">
          <!-- cliparts -->
          <div class="column is-5">
            <div class="columns">
              <div class="column is-9">
                <b-pagination
                  :total="fetchCliparts.length"
                  v-model="current_clipart_page"
                  :per-page="clipart_page_items"
                  aria-next-label="Next page"
                  aria-previous-label="Previous page"
                  aria-page-label="Page"
                  aria-current-label="Current page">
                </b-pagination>
              </div>
              <div class="column is-3">
                <b-numberinput v-model="current_clipart_page" :controls="false"></b-numberinput>
              </div>
            </div>
            <div class="columns is-multiline">
              <div v-for="clipart in currentPageCliparts" :key="clipart._id" style="position: relative;border: 1px solid #ccc;" class="column is-2 has-text-centered">
                <show-image width="80" :src="clipart.file" />
                <div>
                  <div class="buttons">
                    <b-button @click="selectClipart(index, clipart)" type="is-info" size="is-small" outlined>Select</b-button>
                    <b-button @click="selectClipartOverlay(index, clipart)" type="is-dark" size="is-small" outlined>Overlay</b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- clipart ends -->
          <div class="column is-7">
            <div class="columns is-multiline">
              <div class="column">
                <b-field label="No. of images" expanded>
                  <b-numberinput size="is-small" :controls="false" v-model="layer.number"></b-numberinput>
                </b-field>
              </div>
              <div class="column">
                <b-field label="Images in Row" expanded>
                  <b-numberinput size="is-small" :controls="false" v-model="layer.number_row"></b-numberinput>
                </b-field>
              </div>
              <div class="column">
                <b-field label="Resize Type" expanded>
                  <b-select size="is-small" v-model="layer.clipart_resize_type" expanded>
                    <option value="W">Width</option>
                    <option value="H">Height</option>
                  </b-select>
                </b-field>
              </div>
              <div v-if="layer.clipart_resize_type == 'H'" class="column">
                <b-field label="Image Height" expanded>
                  <b-numberinput size="is-small" :controls="false" v-model="layer.clipart_height"></b-numberinput>
                </b-field>
              </div>
              <div v-else class="column">
                <b-field label="Image Width" expanded>
                  <b-numberinput size="is-small" :controls="false" v-model="layer.clipart_width"></b-numberinput>
                </b-field>
              </div>
            </div>
            <div class="columns is-multiline">
              <div class="column">
                <b-field label="Layer Width" expanded>
                  <b-select size="is-small" v-model="layer.layer_width" expanded>
                    <option :value="25">25%</option>
                    <option :value="33">33%</option>
                    <option :value="50">50%</option>
                    <option :value="67">67%</option>
                    <option :value="75">75%</option>
                    <option :value="100">100%</option>
                  </b-select>
                </b-field>
              </div>
              <div class="column">
                <b-field label="Alignment" expanded>
                  <b-select size="is-small" v-model="layer.alignment" expanded>
                    <option value="C">Center</option>
                    <option value="R">Right</option>
                    <option value="L">Left</option>
                  </b-select>
                </b-field>
              </div>
              <div class="column">
                <b-field label="Apply Border" expanded>
                  <b-checkbox v-model="layer.apply_border"></b-checkbox>
                </b-field>
              </div>
              <div class="column">
                <b-field label="Image Margin" expanded>
                  <b-select size="is-small" v-model="layer.image_margin" expanded>
                    <option :value="0">0</option>
                    <option :value="1">1</option>
                    <option :value="2">2</option>
                    <option :value="3">3</option>
                    <option :value="4">4</option>
                    <option :value="5">5</option>
                    <option :value="-0.5">-0.5</option>
                    <option :value="-1">-1</option>
                    <option :value="-2">-2</option>
                    <option :value="-3">-3</option>
                    <option :value="-4">-4</option>
                    <option :value="-5">-5</option>

                  </b-select>
                </b-field>
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <b-field label="Show Border">
                  <b-checkbox v-model="layer.is_layer_border"></b-checkbox>
                </b-field>
              </div>
              
              <div v-if="layer.is_layer_border" class="column">
                <b-field label="Border Color">
                  <b-input v-model="layer.layer_border_color"></b-input>
                </b-field>
              </div>

              <div v-if="layer.is_layer_border" class="column">
                <b-field label="Border Width">
                  <b-numberinput :controls="false" v-model="layer.layer_border_width"></b-numberinput>
                </b-field>
              </div>
            </div>

            <!--Setting Overlay-->
            <div v-if="layer.overlay_clipart" class="columns">
              <div class="column is-4">
                <p class="title is-6">Overlay Image</p>
                <p><show-image width="80" :src="layer.overlay_clipart.file" /></p>
                <b-button @click="removeClipartOverlay(index)" type="is-danger" size="is-small" outlined>Remove Overlay</b-button>
              </div>
              <div class="column is-8">
                <p class="title is-6">Select Images for overlay</p>
                <div class="block">
                  <b-checkbox v-model="layer.overlays" v-for="overlay_no in layer.number" :key="`OVERLAY_CHECKBOX_${overlay_no}`" :native-value="overlay_no" :true-value="overlay_no">Image {{overlay_no}}</b-checkbox>
                </div>
              </div>
            </div>

            <hr />
            <!--Row Styles (For each group)-->
            <div class="columns is-multiline">
              <div class="column is-12">
                <p class="title is-5">Row Properties</p>
              </div>

              <div class="column">
                <b-field label="Show Border">
                  <b-checkbox @input="toggleRowBorderChangeHandler(layer)" v-model="layer.is_row_group_border"></b-checkbox>
                </b-field>
              </div>
              
              <div v-if="layer.is_row_group_border" class="column">
                <b-field label="Border Color">
                  <b-input v-model="layer.row_styles.border_color"></b-input>
                </b-field>
              </div>

              <div v-if="layer.is_row_group_border" class="column">
                <b-field label="Border Width">
                  <b-numberinput :controls="false" v-model="layer.row_styles.border_width"></b-numberinput>
                </b-field>
              </div>

            </div>

            <p class="title is-6">View</p>
            
            <show-clipart-layer :layers="[layer]"></show-clipart-layer>
                   
          </div>
        </div>
      </div>
    </b-collapse>
    <!--For CLipart layers end--> 
  </div>
</template>
<script>
import {mapGetters} from 'vuex'
import ShowImage from '@/components/General/ShowImage'
import ShowClipartLayer from '@/components/Question/ShowClipartLayer'
export default {
  name : 'set-clipart-layer',
  props : {
    value : {
      type : Array
    }, // Here value = new_question.layers (in parent component)
    show_track_count : {
      type : Boolean,
      default : true
    },
    show_add_remove : {
      type : Boolean,
      default : false
    }
  }, 
  components : {
    ShowImage,
    ShowClipartLayer
  },
  data(){
    return {
      layers : this.value,
      isOpen : null,
      clipart_page_items : 50,
      current_clipart_page : 1,
      new_layer : {
        clipart : null,
        tts_text : "",
        overlay_clipart : null,
        overlays : [],
        number : 5,
        number_row : 10,
        clipart_resize_type : 'W',
        clipart_width : 80,
        clipart_height : 80,
        layer_width : 100,
        alignment : "L",
        is_count_tracking : false,
        count_tracking_step : 1,
        apply_border : false,
        image_margin : 1,
        allow_add_remove : false, //Whether allow user to add/remove clipart
        max_display : null, //Max no of clipart to be displayed finally if add remove is yes

        is_row_group_border : false,
        row_styles : {
          border_color : '#ccc',
          border_width : 1,
        },
        is_layer_border : false,
        layer_border_color : '#ccc',
        layer_border_width : 1
      },
    }
  },
  computed : {
    ...mapGetters(['fetchCliparts']),
    currentPageCliparts(){
      // Returns all cliparts of this particular page
      return this.fetchCliparts.slice((this.current_clipart_page-1)*this.clipart_page_items, this.current_clipart_page*this.clipart_page_items)
    },
    currentLayerPage(){
      let page = null
      if(this.layers[this.isOpen]){
        const clipart = this.layers[this.isOpen].clipart
        if(clipart){
          const clipart_id = clipart._id
          const clipart_index = this.fetchCliparts.map(clipart => clipart._id).indexOf(clipart_id)
          page =  Math.floor(clipart_index/this.clipart_page_items) + 1
        }
      }
      return page
    }
  },
  methods : {
    addLayer(){
      // Add a new clipart layer
      const new_layer = JSON.parse(JSON.stringify(this.new_layer))
      this.layers.push(new_layer)
      // Showing message to user
      this.$buefy.toast.open({
        message: "New Layer Added",
        type: "is-success",
      });
    },
    removeLayer(index){
      this.layers.splice(index, 1)

      //Showing message to user
      this.$buefy.toast.open({
        message: "Layer Removed",
        type: "is-success",
      });
    },
    copyLayer(index){
      const layer = JSON.parse(JSON.stringify(this.layers[index]))
      delete layer._id
      this.layers.push(layer)

      //Showing message to user
      this.$buefy.toast.open({
        message: "Layer Copied",
        type: "is-success",
      });
    },
    selectClipart(index, clipart){
      // Select a clipart of this layer
      this.layers[index].clipart = clipart
    },
    selectClipartOverlay(index, clipart){
      // Check if overlay key present in layer, if not add here
      if(!this.layers[index].overlays){
        this.layers[index].overlays = []
      }
      // Select a clipart of this layer
      this.layers[index].overlay_clipart = clipart
      this.layers = JSON.parse(JSON.stringify(this.layers))
    },
    removeClipartOverlay(index){
      // Select a clipart of this layer
      this.layers[index].overlay_clipart = null
    },
    emitData(){
      this.$emit('input', this.layers)
    },
    toggleRowBorderChangeHandler(layer){
      // Adding row_styles object if not present in the layer
      if(!layer.row_styles){
        layer.row_styles = {
          border_color : '#ccc',
          border_width : 1,
        }
      }
    }
  },
  watch : {
    value : function(new_val){
      this.layers = new_val
    },
    layers : {
      handler(){
        this.emitData()
      },
      deep : true
    }
  }
}
</script>
